import Action from 'actions';
import BasePlayer from 'services/sports/default/base-player';
import Const from 'constants';
import {calcUserScore} from "helpers/common-helper";
import {toFloat} from "helpers/number-helper";

export default class Player extends BasePlayer {
    getPlayerById({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const players = preparedPlayers.groupedBy.playerId();

        const [playerId, positionKey] = id.split(Const.LP_ITEM_DELIMITER);

        const player = {...players[playerId]};

        player.position = positionKey ? Number(positionKey) : Number(player.position[0]);

        return player;
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const player = super.getExpandedEntityParams({incomingValues});
        const {userPointsType = 'adminPoints'} = incomingValues;

        player.isDefender = player.positionName === 'DEF';
        player.userScoreMultiplier = 1;
        player.grades = toFloat(player.grades);
        player.dvp = toFloat(player.dvp);
        player.userPoints = toFloat(player[userPointsType], 3);
        player.userScore = calcUserScore(player.userPoints, player.salary, player.userScoreMultiplier);

        return player;
    }
}
